'use client'

import { useState, createContext, useContext } from 'react'
import { LoginModal } from './auth/LoginModal'
import { AccountModal } from './account/AccountModal'

// Create modal context
interface ModalContextType {
  openLoginModal: () => void
  openAccountModal: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}

export function AppLayout({ children }: { children: React.ReactNode }) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false)

  const handleLoginClick = () => {
    setIsLoginModalOpen(true)
  }

  const handleAccountClick = () => {
    setIsAccountModalOpen(true)
  }

  const modalValue: ModalContextType = {
    openLoginModal: handleLoginClick,
    openAccountModal: handleAccountClick,
  }

  return (
    <ModalContext.Provider value={modalValue}>
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => {
          setIsLoginModalOpen(false)
        }}
      />
      <AccountModal
        isOpen={isAccountModalOpen}
        onClose={() => {
          setIsAccountModalOpen(false)
        }}
      />
      <div className="relative flex min-h-screen flex-col">
        <main className="flex-1">{children}</main>
      </div>
    </ModalContext.Provider>
  )
}
